export default __webpack_public_path__ + "mama_johns_logo.79959b02.svg";